// Los sustantivos de la pantalla Mantenciones salen de la receta
// (recipe.labels: «Tienda» / «Tiendas»), nunca de un texto fijo. Los
// fallbacks son los mismos de adminWords («Activos») para el instante
// antes de que cargue la receta; esta sección sólo existe en recetas con
// adminModule, así que nunca se ven con datos reales.

import type { MaintenanceItemAdminSummary, RecipeMeResponse } from "@bitacorapro/api-types";

type WordsRecipe = Pick<RecipeMeResponse, "labels">;

export type MantencionWords = {
  /** «Tienda». */
  asset: string;
  /** «tienda». */
  assetLower: string;
  /** «Tiendas». */
  assetPlural: string;
  /** «tiendas». */
  assetPluralLower: string;
};

function lower(s: string): string {
  return s.charAt(0).toLowerCase() + s.slice(1);
}

export function mantencionWords(recipe: WordsRecipe | undefined): MantencionWords {
  const asset = recipe?.labels?.asset ?? "Activo";
  const assetPlural = recipe?.labels?.assetPlural ?? "Activos";
  return { asset, assetLower: lower(asset), assetPlural, assetPluralLower: lower(assetPlural) };
}

// La columna «Aplica a»: alcance de marca → todas las tiendas (de la
// organización, o de su marca cuando el ítem tiene una); alcance de
// tiendas → cuántas la llevan hoy.
export function appliesToLabel(
  item: Pick<MaintenanceItemAdminSummary, "scope" | "brandId" | "assignedAssetCount">,
  words: MantencionWords,
  brandNameById: ReadonlyMap<string, string>
): string {
  if (item.scope === "brand") {
    if (item.brandId === null) return `Todas las ${words.assetPluralLower}`;
    const name = brandNameById.get(item.brandId);
    return name ? `Marca ${name}` : "Toda la marca";
  }
  const n = item.assignedAssetCount;
  return `${n} ${n === 1 ? words.assetLower : words.assetPluralLower}`;
}
